<app-main-layout>
  <div class="bg-gray-50 min-h-screen">
  <div class="py-6 px-4 sm:px-6 max-w-[1300px] mx-auto pb-10">

    <!-- Page header -->
    <div class="flex flex-row items-center justify-between gap-4 mb-6 flex-wrap">
      <div class="flex items-center gap-4 min-w-0">
        <button (click)="onCancel()" class="h-10 w-10 rounded-full bg-white border border-gray-200 hover:border-amber-300 hover:bg-amber-50 text-gray-500 hover:text-amber-700 flex items-center justify-center shadow-sm transition-colors flex-shrink-0" [matTooltip]="returnToPo ? 'Back to the purchase order' : 'Back to suppliers'" aria-label="Back">
          <mat-icon class="!text-[20px]">arrow_back</mat-icon>
        </button>
        <div class="min-w-0">
          <div class="flex items-center gap-1.5 text-xs text-gray-400 font-medium">
            <a routerLink="/suppliers" class="hover:text-amber-700 transition-colors">Suppliers</a>
            <mat-icon class="!text-[14px] !h-3.5 !w-3.5">chevron_right</mat-icon>
            <span class="text-gray-500">{{ isEditMode ? 'Edit' : 'New' }}</span>
          </div>
          <h1 class="text-2xl font-bold text-gray-900 tracking-tight truncate">{{ isEditMode ? (name || 'Supplier') : 'New supplier' }}</h1>
        </div>
      </div>
      @if (isEditMode && !loading) {
      <button class="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-neutral-900 text-white text-sm font-semibold hover:bg-neutral-700 transition-colors" (click)="onNewPurchaseOrder()" matTooltip="Start a purchase order with this supplier already picked">
        <mat-icon class="!text-[18px] !h-[18px] !w-[18px] !text-amber-400">add_shopping_cart</mat-icon> New purchase order
      </button>
      }
    </div>

    @if (returnToPo && !isEditMode) {
    <div class="mb-6 flex items-center gap-3 rounded-2xl border border-sky-100 bg-sky-50 px-4 py-3 text-sm text-sky-900">
      <mat-icon class="!text-[20px] !h-5 !w-5 !text-sky-500 flex-shrink-0">info</mat-icon>
      <span>Once this supplier is saved you'll go straight back to a new purchase order with them already picked.</span>
    </div>
    }

    @if (loading) {
      <div class="po-card min-h-80 flex flex-col justify-center items-center">
        <mat-spinner diameter="32"></mat-spinner>
        <div class="text-sm text-gray-500 mt-3">Loading supplier&hellip;</div>
      </div>
    } @else {
    <div class="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_360px] gap-6 items-start">

      <!-- ============ FORM ============ -->
      <div class="flex flex-col gap-6 min-w-0">

        <!-- Company -->
        <section id="sec-company" class="po-card scroll-mt-20">
          <div class="flex items-center gap-3 mb-5">
            <span class="po-card-icon"><mat-icon class="!text-[20px] !h-5 !w-5">business</mat-icon></span>
            <div><div class="font-bold text-gray-900 leading-tight">Company</div><div class="text-xs text-gray-400">Who you buy from</div></div>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-4">
            <div class="sm:col-span-2">
              <label class="po-label" for="sup-name">Supplier name <span class="text-red-500">*</span></label>
              <div class="relative">
                <mat-icon class="absolute left-3 top-1/2 -translate-y-1/2 !text-gray-400 !text-[18px] !h-[18px] !w-[18px] pointer-events-none">storefront</mat-icon>
                <input id="sup-name" type="text" placeholder="e.g. Rajasthan Stone Exports Pvt Ltd" class="po-field !pl-10 !text-base font-semibold"
                  [ngClass]="(submitted && !name.trim()) ? '!border-red-300' : (duplicateSupplier ? '!border-amber-300' : '')" [(ngModel)]="name" />
              </div>
              @if (submitted && !name.trim()) {
              <div class="text-xs text-red-600 mt-1.5">Supplier name is required</div>
              } @else {
              @if (duplicateSupplier; as dup) {
              <div class="text-xs text-amber-800 mt-1.5 flex items-center gap-1.5 flex-wrap">
                <mat-icon class="!text-[14px] !h-3.5 !w-3.5">warning_amber</mat-icon>
                A supplier called "{{ dup.name }}" already exists.
                <a class="font-semibold underline hover:text-amber-900" [routerLink]="['/suppliers/edit', dup.id]">Open it instead</a>
              </div>
              }
              }
            </div>
            <div>
              <label class="po-label" for="sup-vat">VAT number</label>
              <div class="relative">
                <mat-icon class="absolute left-3 top-1/2 -translate-y-1/2 !text-gray-400 !text-[18px] !h-[18px] !w-[18px] pointer-events-none">receipt</mat-icon>
                <input id="sup-vat" type="text" placeholder="e.g. GB123456789" class="po-field !pl-10 font-mono uppercase" [(ngModel)]="vatNumber" />
              </div>
            </div>
            <div>
              <label class="po-label" for="sup-web">Website</label>
              <div class="relative">
                <mat-icon class="absolute left-3 top-1/2 -translate-y-1/2 !text-gray-400 !text-[18px] !h-[18px] !w-[18px] pointer-events-none">language</mat-icon>
                <input id="sup-web" type="url" placeholder="example.com" class="po-field !pl-10 !pr-10" [(ngModel)]="website" />
                @if (website.trim()) {
                <a class="absolute right-2 top-1/2 -translate-y-1/2 h-7 w-7 rounded-full text-gray-400 hover:bg-amber-50 hover:text-amber-700 flex items-center justify-center transition-colors" [href]="websiteUrl" target="_blank" rel="noopener" matTooltip="Open website" aria-label="Open website">
                  <mat-icon class="!text-[16px] !h-4 !w-4">open_in_new</mat-icon>
                </a>
                }
              </div>
            </div>
          </div>
        </section>

        <!-- Contact -->
        <section id="sec-contact" class="po-card scroll-mt-20">
          <div class="flex items-center gap-3 mb-5">
            <span class="po-card-icon"><mat-icon class="!text-[20px] !h-5 !w-5">contact_mail</mat-icon></span>
            <div><div class="font-bold text-gray-900 leading-tight">Contact</div><div class="text-xs text-gray-400">How to reach them about orders</div></div>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-4">
            <div>
              <label class="po-label" for="sup-email">Email</label>
              <div class="relative">
                <mat-icon class="absolute left-3 top-1/2 -translate-y-1/2 !text-gray-400 !text-[18px] !h-[18px] !w-[18px] pointer-events-none">mail</mat-icon>
                <input id="sup-email" type="email" placeholder="orders@supplier.com" class="po-field !pl-10 !pr-10" [ngClass]="emailInvalid ? '!border-red-300' : ''" [(ngModel)]="email" />
                @if (email.trim() && !emailInvalid) {
                <mat-icon class="absolute right-3 top-1/2 -translate-y-1/2 !text-[18px] !h-[18px] !w-[18px] !text-emerald-500 pointer-events-none">check_circle</mat-icon>
                }
              </div>
              @if (emailInvalid) {
              <div class="text-xs text-red-600 mt-1.5">That doesn't look like a valid email address</div>
              } @else if (!email.trim()) {
              <div class="text-[11px] text-gray-400 mt-1.5">Needed to send purchase orders to them</div>
              }
            </div>
            <div>
              <label class="po-label" for="sup-phone">Phone</label>
              <div class="relative">
                <mat-icon class="absolute left-3 top-1/2 -translate-y-1/2 !text-gray-400 !text-[18px] !h-[18px] !w-[18px] pointer-events-none">call</mat-icon>
                <input id="sup-phone" type="tel" placeholder="+44 1234 567890" class="po-field !pl-10" [(ngModel)]="phone" />
              </div>
            </div>
          </div>
        </section>

        <!-- Address -->
        <section id="sec-address" class="po-card scroll-mt-20">
          <div class="flex items-center justify-between gap-3 mb-5 flex-wrap">
            <div class="flex items-center gap-3">
              <span class="po-card-icon"><mat-icon class="!text-[20px] !h-5 !w-5">place</mat-icon></span>
              <div><div class="font-bold text-gray-900 leading-tight">Address</div><div class="text-xs text-gray-400">Shown on purchase orders</div></div>
            </div>
            @if (hasAddress) {
            <a class="flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-lg text-amber-700 hover:bg-amber-50 transition-colors" [href]="mapsUrl" target="_blank" rel="noopener">
              <mat-icon class="!text-[16px] !h-4 !w-4">map</mat-icon> View on map
            </a>
            }
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-6 gap-x-5 gap-y-4">
            <div class="sm:col-span-6">
              <label class="po-label" for="sup-a1">Address line 1</label>
              <input id="sup-a1" type="text" placeholder="Building, street" class="po-field" [(ngModel)]="addressLine1" />
            </div>
            <div class="sm:col-span-6">
              <label class="po-label" for="sup-a2">Address line 2 <span class="normal-case tracking-normal font-normal text-gray-400">(optional)</span></label>
              <input id="sup-a2" type="text" placeholder="Area, industrial estate" class="po-field" [(ngModel)]="addressLine2" />
            </div>
            <div class="sm:col-span-3">
              <label class="po-label" for="sup-city">City</label>
              <input id="sup-city" type="text" placeholder="City" class="po-field" [(ngModel)]="city" />
            </div>
            <div class="sm:col-span-3">
              <label class="po-label" for="sup-pc">Postcode</label>
              <input id="sup-pc" type="text" placeholder="Postcode / PIN" class="po-field uppercase" [(ngModel)]="postcode" />
            </div>
            <div class="sm:col-span-6">
              <label class="po-label" for="sup-country">Country</label>
              <div class="relative">
                <span class="absolute left-3 top-1/2 -translate-y-1/2 text-lg leading-none pointer-events-none">
                  @if (countryMatch; as c) { {{ countryFlag(c.code) }} } @else { <mat-icon class="!text-gray-400 !text-[18px] !h-[18px] !w-[18px] align-middle">public</mat-icon> }
                </span>
                <input id="sup-country" type="text" autocomplete="off" placeholder="Search countries" class="po-field !pl-11"
                  [value]="country" [matAutocomplete]="countryAuto" (input)="country = $any($event.target).value" />
              </div>
              <mat-autocomplete #countryAuto="matAutocomplete" class="po-ac-panel" [hideSingleSelectionIndicator]="true" (optionSelected)="country = $event.option.value">
                @for (c of filteredCountries; track c.code) {
                <mat-option [value]="c.name">
                  <div class="flex items-center gap-3 py-1.5 text-sm">
                    <span class="text-lg leading-none">{{ countryFlag(c.code) }}</span>
                    <span class="text-gray-900">{{ c.name }}</span>
                    <span class="ml-auto text-[11px] font-mono text-gray-400">{{ c.code }}</span>
                  </div>
                </mat-option>
                }
              </mat-autocomplete>
              @if (country.trim() && !countryMatch) {
              <div class="text-[11px] text-gray-400 mt-1.5">Not in the list - it'll be saved as typed.</div>
              }
            </div>
          </div>
        </section>

        <!-- Notes -->
        <section id="sec-notes" class="po-card scroll-mt-20">
          <div class="flex items-center gap-3 mb-4">
            <span class="po-card-icon"><mat-icon class="!text-[20px] !h-5 !w-5">sticky_note_2</mat-icon></span>
            <div><div class="font-bold text-gray-900 leading-tight">Notes</div><div class="text-xs text-gray-400">Anything the team should know when ordering</div></div>
          </div>
          <div class="flex flex-wrap gap-2 mb-3">
            @for (s of noteStarters; track s) {
            <button type="button" class="inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-1 rounded-full border border-gray-200 bg-white text-gray-600 hover:border-amber-300 hover:bg-amber-50 hover:text-amber-800 transition-colors" (click)="addNoteStarter(s, notesBox)">
              <mat-icon class="!text-[14px] !h-3.5 !w-3.5">add</mat-icon>{{ s }}
            </button>
            }
          </div>
          <textarea #notesBox rows="5" placeholder="e.g. Lead time: 8-10 weeks from deposit&#10;Minimum order: one 20ft container" class="po-field resize-y leading-relaxed" [(ngModel)]="notes"></textarea>
        </section>
      </div>
      <!-- ============ /FORM ============ -->

      <!-- ============ SIDEBAR ============ -->
      <div class="flex flex-col gap-6">

        <!-- Preview -->
        <div class="po-card !p-0 overflow-hidden">
          <div class="h-20 bg-gradient-to-br from-neutral-900 via-neutral-800 to-neutral-700 relative">
            @if (countryMatch; as c) {
            <span class="absolute right-4 top-3 text-2xl" [matTooltip]="c.name">{{ countryFlag(c.code) }}</span>
            }
          </div>
          <div class="px-6 pb-6 -mt-8">
            <div class="h-16 w-16 rounded-2xl bg-amber-400 text-neutral-900 text-xl font-bold flex items-center justify-center ring-4 ring-white shadow">{{ initials }}</div>
            <div class="mt-3 font-bold text-lg leading-snug break-words" [ngClass]="name ? 'text-gray-900' : 'text-gray-300'">{{ name || 'Unnamed supplier' }}</div>
            <div class="mt-1.5 flex flex-wrap gap-1.5">
              @if (country) { <span class="flex items-center gap-1 text-[11px] font-semibold px-2 py-0.5 rounded-full bg-gray-100 text-gray-600"><mat-icon class="!text-[13px] !h-[13px] !w-[13px]">public</mat-icon>{{ country }}</span> }
              @if (vatNumber) { <span class="text-[11px] font-mono uppercase px-2 py-0.5 rounded-full bg-gray-50 text-gray-500 border border-gray-100">VAT {{ vatNumber }}</span> }
            </div>
            <div class="mt-4 pt-4 border-t border-gray-100 flex flex-col gap-2.5 text-sm">
              @if (email && !emailInvalid) {
              <a class="flex items-center gap-2.5 text-gray-700 hover:text-amber-700 min-w-0" [href]="'mailto:' + email"><mat-icon class="!text-[16px] !h-4 !w-4 !text-gray-400 flex-shrink-0">mail</mat-icon><span class="truncate">{{ email }}</span></a>
              }
              @if (phone) {
              <a class="flex items-center gap-2.5 text-gray-700 hover:text-amber-700" [href]="'tel:' + phone"><mat-icon class="!text-[16px] !h-4 !w-4 !text-gray-400">call</mat-icon>{{ phone }}</a>
              }
              @if (website) {
              <a class="flex items-center gap-2.5 text-gray-700 hover:text-amber-700 min-w-0" [href]="websiteUrl" target="_blank" rel="noopener"><mat-icon class="!text-[16px] !h-4 !w-4 !text-gray-400 flex-shrink-0">language</mat-icon><span class="truncate">{{ website }}</span></a>
              }
              @if (hasAddress) {
              <a class="flex items-start gap-2.5 text-gray-600 hover:text-amber-700" [href]="mapsUrl" target="_blank" rel="noopener"><mat-icon class="!text-[16px] !h-4 !w-4 !text-gray-400 mt-0.5 flex-shrink-0">place</mat-icon><span>{{ addressSummary }}</span></a>
              }
              @if (!email && !phone && !website && !hasAddress) {
              <span class="text-gray-300 text-xs">Contact details show here as you fill them in</span>
              }
            </div>
          </div>
        </div>

        <!-- Completeness -->
        <div class="po-card">
          <div class="flex items-center justify-between mb-2">
            <div class="font-bold text-gray-900">Profile</div>
            <span class="text-xs font-semibold" [ngClass]="completePct === 100 ? 'text-emerald-600' : 'text-gray-500'">{{ completePct }}% complete</span>
          </div>
          <div class="h-1.5 rounded-full bg-gray-100 overflow-hidden mb-4">
            <div class="h-full rounded-full transition-all duration-300" [ngClass]="completePct === 100 ? 'bg-emerald-500' : 'bg-amber-400'" [style.width.%]="completePct"></div>
          </div>
          <div class="flex flex-col -mx-2">
            @for (c of checklist; track c.label) {
            <button type="button" class="flex items-center gap-2.5 px-2 py-1.5 rounded-lg text-sm text-left hover:bg-gray-50 transition-colors" (click)="scrollTo(c.section)">
              <mat-icon class="!text-[18px] !h-[18px] !w-[18px] flex-shrink-0" [ngClass]="c.done ? '!text-emerald-500' : '!text-gray-300'">{{ c.done ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
              <span [ngClass]="c.done ? 'text-gray-500' : 'text-gray-800 font-medium'">{{ c.label }}</span>
              @if (!c.done) { <mat-icon class="ml-auto !text-[16px] !h-4 !w-4 !text-gray-300">chevron_right</mat-icon> }
            </button>
            }
          </div>
        </div>

        <!-- Order history -->
        @if (isEditMode) {
        <div class="po-card">
          <div class="flex items-center justify-between mb-4">
            <div class="font-bold text-gray-900">Purchase orders</div>
            <span class="text-xs text-gray-400">{{ purchaseOrders.length }} total</span>
          </div>

          @if (purchaseOrders.length === 0) {
            <div class="rounded-2xl border-2 border-dashed border-gray-200 py-8 px-4 flex flex-col items-center text-center">
              <span class="h-11 w-11 rounded-2xl bg-amber-50 text-amber-600 flex items-center justify-center"><mat-icon>inventory_2</mat-icon></span>
              <div class="text-sm text-gray-500 mt-2">No purchase orders with this supplier yet</div>
              <button class="mt-3 text-xs font-semibold px-3.5 py-2 rounded-xl bg-neutral-900 text-white hover:bg-neutral-700 transition-colors" (click)="onNewPurchaseOrder()">Raise the first one</button>
            </div>
          } @else {
            <div class="grid grid-cols-2 gap-3 mb-4">
              <div class="rounded-xl bg-amber-50 border border-amber-100 p-3">
                <div class="text-[10px] uppercase tracking-wider text-amber-700/70 font-semibold">Open</div>
                <div class="text-2xl font-bold text-amber-700 po-tabular">{{ openOrders }}</div>
              </div>
              <div class="rounded-xl bg-gray-50 border border-gray-100 p-3 min-w-0">
                <div class="text-[10px] uppercase tracking-wider text-gray-400 font-semibold">Ordered (ex tax)</div>
                @for (t of spendByCurrency; track t.currency) {
                <div class="text-sm font-bold text-gray-800 truncate po-tabular">{{ t.total | currency:t.currency:'symbol':'1.0-0' }}</div>
                }
              </div>
            </div>
            <div class="flex flex-col -mx-2 max-h-[420px] overflow-y-auto">
              @for (o of purchaseOrders; track o.id) {
              <button class="text-left px-2 py-2.5 rounded-xl hover:bg-amber-50/60 transition-colors" (click)="onOpenOrder(o)">
                <div class="flex items-center justify-between gap-2">
                  <span class="font-semibold text-sm text-gray-900">{{ o.reference }}</span>
                  <span class="text-sm font-semibold text-gray-700 po-tabular">{{ o.itemsTotal | currency:o.currency:'symbol':'1.0-0' }}</span>
                </div>
                <div class="mt-1 flex items-center justify-between gap-2">
                  <span class="text-xs text-gray-400">{{ o.orderDate | date:'d MMM yyyy' }}</span>
                  <span class="flex items-center gap-1.5">
                    <span class="text-[10px] font-semibold px-2 py-0.5 rounded-full capitalize" [ngClass]="statusClass(o.status)">{{ o.status | lowercase }}</span>
                    <span class="text-[10px] font-semibold px-2 py-0.5 rounded-full capitalize" [ngClass]="billingClass(o.billingStatus)">{{ o.billingStatus | lowercase }}</span>
                  </span>
                </div>
              </button>
              }
            </div>
          }
        </div>
        }
      </div>
      <!-- ============ /SIDEBAR ============ -->
    </div>
    }

  </div>

  <!-- Sticky save bar -->
  @if (!loading) {
  <div class="sticky bottom-0 z-20 bg-white/90 backdrop-blur border-t border-gray-200 shadow-[0_-4px_16px_-8px_rgba(0,0,0,0.08)]">
    <div class="max-w-[1300px] mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
      <div class="hidden sm:flex items-center gap-3 text-sm min-w-0">
        <span class="text-gray-400 truncate">{{ isEditMode ? 'Editing ' + (name || 'supplier') : 'New supplier' }}</span>
        @for (b of saveBlockers; track b) {
        <span class="inline-flex items-center gap-1 text-xs font-semibold text-amber-800 bg-amber-50 border border-amber-200 rounded-full px-2.5 py-1 whitespace-nowrap"><mat-icon class="!text-[14px] !h-3.5 !w-3.5">radio_button_unchecked</mat-icon>{{ b }}</span>
        } @empty {
        <span class="inline-flex items-center gap-1 text-xs font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full px-2.5 py-1 whitespace-nowrap"><mat-icon class="!text-[14px] !h-3.5 !w-3.5">check_circle</mat-icon>Ready to save</span>
        }
      </div>
      <div class="flex items-center gap-3 ml-auto">
        <button class="px-5 py-2.5 rounded-xl border border-gray-200 bg-white text-gray-700 text-sm font-semibold hover:bg-gray-50 transition-colors" (click)="onCancel()">Cancel</button>
        <button
          class="flex items-center gap-2 px-6 py-2.5 rounded-xl bg-gradient-to-b from-amber-400 to-amber-500 text-neutral-900 font-bold text-sm shadow-md shadow-amber-200 hover:from-amber-300 hover:to-amber-400 active:scale-[0.98] transition-all disabled:opacity-60 disabled:cursor-not-allowed"
          [disabled]="saving" (click)="onSave()">
          @if (saving) { <mat-spinner diameter="16"></mat-spinner> } @else { <mat-icon class="!text-[18px] !h-[18px] !w-[18px]">check</mat-icon> }
          {{ saving ? 'Saving…' : (isEditMode ? 'Save changes' : (returnToPo ? 'Create & back to PO' : 'Create supplier')) }}
        </button>
      </div>
    </div>
  </div>
  }
  </div>
</app-main-layout>
